import { type PropsWithChildren, type ReactNode, createContext, useContext } from "react";
import type { NavigateOptions } from "react-router";

export interface RenderUserDetailsCardProps {
    userId: string;
    displayName: string;
    routerOptions?: NavigateOptions;
    isExternal?: boolean;
    children: ReactNode;
    fallback: ReactNode;
}

export type RenderUserDetailsCard = (props: RenderUserDetailsCardProps) => ReactNode;

const UserDetailsCardContext = createContext<RenderUserDetailsCard | null>(null);

export interface UserDetailsCardProviderProps extends PropsWithChildren {
    renderUserDetailsCard: RenderUserDetailsCard;
}

export function UserDetailsCardProvider({ renderUserDetailsCard, children }: UserDetailsCardProviderProps) {
    return <UserDetailsCardContext.Provider value={renderUserDetailsCard}>{children}</UserDetailsCardContext.Provider>;
}

export function useRenderUserDetailsCard() {
    return useContext(UserDetailsCardContext);
}
